import { takeEvery, call, put, fork } from 'redux-saga/effects';
import { loadIsler, saveIsler } from 'src/utils/storage/WorkOrder';
import { setIslerAdet } from 'src/utils/storage/NavBarAdet';
import * as actions from '../actions/taskActions';
import * as Defectactions from '../actions/defectActions';
import * as Labouractions from '../actions/labourActions';
import * as Materialactions from '../actions/materialActions';
import * as api from '../api/tasks';
import moment from 'moment';
import { maskStringData, maskPhoneData } from 'src/MaskData';
import { getAuthorizedUser, getUser, moneyFormat } from 'src/utils/Common';

function* getTasks(WorkOrderId) {
  try {
    let result = '';
    // if (window.navigator.onLine) {
    result = yield call(api.getTasks, WorkOrderId);
    // saveIsler(result.data);
    // setIslerAdet(result.data.length);
    const current = result.data;
    // serdar yeni yazıyor....
    if (current && current.length > 0) {
      const curr = current[0];
      const { ModelCode } = curr;
      const WarrantyTypeId = curr.WarrantyTypeId || 0;
      const ProductionYear = curr.ProductionYear || 0;
      const ProductionMonth = curr.ProductionMonth || 0;
      const WorkOrderIdParam = curr.ReceiptNo || 0;

      if (
        ModelCode !== undefined &&
        ModelCode !== null &&
        ModelCode.length > 0
      ) {
        yield put(Defectactions.resetDefects());
        yield put(Materialactions.resetMaterials());
        yield put(Labouractions.resetLabours());
        if (curr.WorkOrderDetails) {
          yield put(
            Defectactions.getDefectRequest(
              ModelCode,
              WarrantyTypeId,
              curr.WorkOrderDetails
            )
          );
          yield put(
            Labouractions.getLabourRequest(
              ModelCode,
              WarrantyTypeId,
              1,
              curr.WorkOrderLabours,
              curr.ReceiptNo
            )
          );
          yield put(
            Materialactions.getMaterialRequest(
              ModelCode,
              WarrantyTypeId,
              1,
              ProductionYear,
              ProductionMonth,
              WorkOrderIdParam,
              curr.WorkOrderMaterials
            )
          );
        }
      }
    }
    // serdar yeni yazıyor....

    yield put(actions.getTasksSuccess(result.data));
    // } else {
    //   result = loadIsler();
    //   setIslerAdet(result.length);
    //   yield put(actions.getTasksSuccess(result));
    // }
  } catch (error) {
    const resultError = loadIsler();
    setIslerAdet(resultError.length);
    yield put(actions.getTasksSuccess(resultError));
  }
}

function* watchGetTaskRequest() {
  yield takeEvery(actions.Types.GET_TASK_REQUEST, getTasks);
}

function* getFilteredTasks(model) {
  try {
    yield put(actions.setRequestStatus(true));
    yield put(actions.setFilteredTasksError(false));

    var resetModel = {
      excelDetailedDatas: [],
      tasksScreenResult: []
    };

    yield put(actions.setFilteredTasks(resetModel));

    const apiResult = yield call(api.getFilteredTasks, model.payload);
    let ResponseData = [];

    if (apiResult?.data?.length === 0) {
      yield put(actions.setRequestStatus(false));
      return [];
    }

    const SessionUser = getUser();
    const isTenantId82 = SessionUser.TenantId === 82;
    const isTenantId70 = SessionUser.TenantId === 70;

    let taskScreenResult = [];


    ResponseData = apiResult.data;

    for (var i = 0; i < ResponseData.length; i++) {
      var tmp = {
        id: i + 1,
        lblWorkCaseId: ResponseData[i].WorkCaseId,
        lblWorkOrderId: ResponseData[i].id,
        lblServiceCode: ResponseData[i].ServiceCode,
        lblServiceShop: ResponseData[i].ServiceShop,
        lblWarrantyDate: moment(ResponseData[i].WarrantyDate).format('DD/MM/YYYY'),
        lblWarrantyType: ResponseData[i].WarrantyType,
        lblOpenDays: ResponseData[i].OpenDays,
        lblStatus: ResponseData[i].Status,
        lblStatusNote: ResponseData[i].StatusNote,
        lblCallCenterNote: ResponseData[i].CallCenterNote,
        lblRejectDescription: ResponseData[i].RealRejectReason,
        lblSpecialNote: ResponseData[i].SpecialNote,
        lblFinalNote: ResponseData[i].FinalNote,
        lblUrgentCustomer: ResponseData[i].UrgentCustomer === 1 ? 'URGENT' : '',
        lblCustomer: isTenantId82 || isTenantId70 ?
          ResponseData[i].Consumer[0]?.Search :
          maskStringData(ResponseData[i].Consumer[0]?.Search),
        CustomerRegion: ResponseData[i].Consumer[0]?.Addresses[0]?.Region,
        CustomerDistrict: ResponseData[i].Consumer[0]?.Addresses[0]?.District,
        CustomerCity: ResponseData[i].Consumer[0]?.Addresses[0]?.City,
        CustomerAddress: ResponseData[i].Consumer && ResponseData[i].Consumer[0]?.Addresses ?
          (isTenantId82 || isTenantId70 ?
            ResponseData[i].Consumer[0]?.Addresses[0]?.Address :
            maskStringData(ResponseData[i].Consumer[0]?.Addresses[0]?.Address)
          ) : '',
        CustomerPhone: ResponseData[i].Consumer[0]?.Phones ?
          (isTenantId82 || isTenantId70 ?
            ResponseData[i].Consumer[0]?.Phones[0]?.Phone :
            maskPhoneData(ResponseData[i].Consumer[0]?.Phones[0]?.Phone)
          ) : '',
        lblBrand: ResponseData[i].Brand,
        lblProductGroup: ResponseData[i].ProductGroup,
        lblSerialNumber: ResponseData[i].SerialNumber === '000000' || ResponseData[i].SerialNumber === '000000000' ? '' : ResponseData[i].SerialNumber,
        lblProductCode: ResponseData[i].ProductCode,
        lblProduct: ResponseData[i].Product,
        lblCallDate: moment(ResponseData[i].OpenDate).format('DD/MM/YYYY HH:mm'),
        lblRepairDate: ResponseData[i].RepairDate ? moment(ResponseData[i].RepairDate).format('DD/MM/YYYY HH:mm') : '',
        lblTechnician: ResponseData[i].Technician,
        lblRetailer: ResponseData[i].Retailer,
        lblApplicationType: ResponseData[i].Issue,
        lblMaterialOrderList: ResponseData[i].MaterialOrderId,
        lblLabourPrice: moneyFormat(ResponseData[i].LabourPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
        lblMaterialPrice: moneyFormat(ResponseData[i].MaterialPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
        lblTransportPrice: moneyFormat(ResponseData[i].TransportPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
        lblExtraPrice: moneyFormat(ResponseData[i].ExtraPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
        lblTotalPrice: moneyFormat(ResponseData[i].TotalPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
        lblCreateUser: ResponseData[i].CreateUser,
        lblUpdateUser: ResponseData[i].UpdateUser,
        lblLastWorkOrder: ResponseData[i].IsThisLastWorkOrder,
        lblAppointmentDate: ResponseData[i].AppointmentDate,
        lblPostalCode: ResponseData[i]["Consumer"][0]["Addresses"][0].PostCode,
        lblPlaceOfOperation: ResponseData[i].PlaceOfOperation
      }
      taskScreenResult.push(tmp)
    }

    var result = []
    for (var i = 0; i < ResponseData.length; i++) {
      if (ResponseData[i].WorkOrderDetails.length === 0) {
        var tmp = {
          lblWorkCaseId: ResponseData[i].WorkCaseId,
          lblWorkOrderId: ResponseData[i].id,
          lblServiceCode: ResponseData[i].ServiceCode,
          lblServiceShop: ResponseData[i].ServiceShop,
          lblWarrantyDate: moment(ResponseData[i].WarrantyDate).format('DD/MM/YYYY'),
          lblOpenDays: ResponseData[i].OpenDays,
          lblWarrantyType: ResponseData[i].WarrantyType,
          lblStatus: ResponseData[i].Status,
          lblStatusNote: ResponseData[i].StatusNote,
          lblCallCenterNote: ResponseData[i].CallCenterNote,
          lblRejectDescription: ResponseData[i].RealRejectReason,
          lblSpecialNote: ResponseData[i].SpecialNote,
          lblFinalNote: ResponseData[i].FinalNote,
          lblUrgentCustomer: ResponseData[i].UrgentCustomer === 1 ? 'URGENT' : '',
          lblCustomer: isTenantId82 || isTenantId70 ?
            ResponseData[i].Consumer[0]?.Search :
            maskStringData(ResponseData[i].Consumer[0]?.Search),
          CustomerRegion: ResponseData[i].Consumer && ResponseData[i].Consumer[0]?.Addresses ?
            ResponseData[i].Consumer[0]?.Addresses[0]?.Region : '',
          CustomerDistrict: ResponseData[i].Consumer && ResponseData[i].Consumer[0]?.Addresses ?
            ResponseData[i].Consumer[0]?.Addresses[0]?.District : '',
          CustomerCity: ResponseData[i].Consumer && ResponseData[i].Consumer[0]?.Addresses ?
            ResponseData[i].Consumer[0]?.Addresses[0]?.City : '',
          CustomerAddress: ResponseData[i].Consumer && ResponseData[i].Consumer[0]?.Addresses ?
            (isTenantId82 || isTenantId70 ?
              ResponseData[i].Consumer[0]?.Addresses[0]?.Address :
              maskStringData(ResponseData[i].Consumer[0]?.Addresses[0]?.Address)
            ) : '',
          CustomerPhone: ResponseData[i].Consumer[0]?.Phones ?
            (isTenantId82 || isTenantId70 ?
              ResponseData[i].Consumer[0]?.Phones[0]?.Phone :
              maskPhoneData(ResponseData[i].Consumer[0]?.Phones[0]?.Phone)
            ) : '',
          lblBrand: ResponseData[i].Brand,
          lblSerialNumber: ResponseData[i].SerialNumber === '000000' || ResponseData[i].SerialNumber === '000000000' ? '' : ResponseData[i].SerialNumber,
          lblProductGroup: ResponseData[i].ProductGroup,
          lblProductCode: ResponseData[i].ProductCode,
          lblProduct: ResponseData[i].Product,
          lblCallDate: moment(ResponseData[i].OpenDate).format('DD/MM/YYYY HH:mm'),
          lblRepairDate: ResponseData[i].RepairDate ? moment(ResponseData[i].RepairDate).format('DD/MM/YYYY HH:mm') : '',
          lblTechnician: ResponseData[i].Technician,
          lblRetailer: ResponseData[i].Retailer,
          lblApplicationType: ResponseData[i].Issue,
          lblMaterialOrderList: ResponseData[i].MaterialOrderId,
          // LabourPrice: moneyFormat(ResponseData[i].LabourPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
          // MaterialPrice: moneyFormat(ResponseData[i].MaterialPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
          // TransportPrice: moneyFormat(ResponseData[i].TransportPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
          // ExtraPrice: moneyFormat(ResponseData[i].ExtraPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
          // TotalPrice: moneyFormat(ResponseData[i].TotalPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
          lblCreateUser: ResponseData[i].CreateUser,
          lblUpdateUser: ResponseData[i].UpdateUser,
          lblLastWorkOrder: ResponseData[i].IsThisLastWorkOrder,
          lblDefectName: '',
          lblMaterialType: '',
          lblMaterialName: '',
          lblMaterialCode: '',
          lblVatRate: '',
          lblPrice: '',
          lblPriceWithVat: '',
          lblDiscountPrice: '',
          lblCurrencyId: '',
          lblQuantity: '',
          lblProjectCode: ResponseData[i].ProjectCode,
          lblAppointmentDate: ResponseData[i].AppointmentDate,
          lblPostalCode: ResponseData[i]["Consumer"][0]["Addresses"][0].PostCode,
          lblPlaceOfOperation: ResponseData[i].PlaceOfOperation
        }
        result.push(tmp)
      }
      else {
        for (var j = 0; j < ResponseData[i].WorkOrderDetails.length; j++) {
          var tmp = {
            lblWorkCaseId: ResponseData[i].WorkCaseId,
            lblWorkOrderId: ResponseData[i].id,
            lblServiceCode: ResponseData[i].ServiceCode,
            lblServiceShop: ResponseData[i].ServiceShop,
            lblWarrantyDate: moment(ResponseData[i].WarrantyDate).format('DD/MM/YYYY'),
            lblOpenDays: ResponseData[i].OpenDays,
            lblWarrantyType: ResponseData[i].WarrantyType,
            lblStatus: ResponseData[i].Status,
            lblStatusNote: ResponseData[i].StatusNote,
            lblCallCenterNote: ResponseData[i].CallCenterNote,
            lblRejectDescription: ResponseData[i].RealRejectReason,
            lblSpecialNote: ResponseData[i].SpecialNote,
            lblFinalNote: ResponseData[i].FinalNote,
            lblUrgentCustomer: ResponseData[i].UrgentCustomer === 1 ? 'URGENT' : '',
            lblCustomer: isTenantId82 || isTenantId70 ?
              ResponseData[i].Consumer[0]?.Search :
              maskStringData(ResponseData[i].Consumer[0]?.Search),
            CustomerRegion: ResponseData[i].Consumer && ResponseData[i].Consumer[0]?.Addresses ?
              ResponseData[i].Consumer[0]?.Addresses[0]?.Region : '',
            CustomerDistrict: ResponseData[i].Consumer && ResponseData[i].Consumer[0]?.Addresses ?
              ResponseData[i].Consumer[0]?.Addresses[0]?.District : '',
            CustomerCity: ResponseData[i].Consumer && ResponseData[i].Consumer[0]?.Addresses ?
              ResponseData[i].Consumer[0]?.Addresses[0]?.City : '',
            CustomerAddress: ResponseData[i].Consumer && ResponseData[i].Consumer[0]?.Addresses ?
              (isTenantId82 || isTenantId70 ?
                ResponseData[i].Consumer[0]?.Addresses[0]?.Address :
                maskStringData(ResponseData[i].Consumer[0]?.Addresses[0]?.Address)
              ) : '',
            CustomerPhone: ResponseData[i].Consumer[0]?.Phones ?
              (isTenantId82 || isTenantId70 ?
                ResponseData[i].Consumer[0]?.Phones[0]?.Phone :
                maskPhoneData(ResponseData[i].Consumer[0]?.Phones[0]?.Phone)
              ) : '',
            lblBrand: ResponseData[i].Brand,
            lblSerialNumber: ResponseData[i].SerialNumber === '000000' || ResponseData[i].SerialNumber === '000000000' ? '' : ResponseData[i].SerialNumber,
            lblProductGroup: ResponseData[i].ProductGroup,
            lblProductCode: ResponseData[i].ProductCode,
            lblProduct: ResponseData[i].Product,
            lblCallDate: moment(ResponseData[i].OpenDate).format('DD/MM/YYYY HH:mm'),
            lblRepairDate: ResponseData[i].RepairDate ? moment(ResponseData[i].RepairDate).format('DD/MM/YYYY HH:mm') : '',
            lblTechnician: ResponseData[i].Technician,
            lblRetailer: ResponseData[i].Retailer,
            lblApplicationType: ResponseData[i].Issue,
            lblMaterialOrderList: ResponseData[i].MaterialOrderId,
            // LabourPrice: moneyFormat(ResponseData[i].LabourPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
            // MaterialPrice: moneyFormat(ResponseData[i].MaterialPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
            // TransportPrice: moneyFormat(ResponseData[i].TransportPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
            // ExtraPrice: moneyFormat(ResponseData[i].ExtraPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
            // TotalPrice: moneyFormat(ResponseData[i].TotalPrice, SessionUser.TenantCode, SessionUser.CurrencyUnit),
            lblCreateUser: ResponseData[i].CreateUser,
            lblUpdateUser: ResponseData[i].UpdateUser,
            lblLastWorkOrder: ResponseData[i].IsThisLastWorkOrder,
            //WorkOrderDetailId: ResponseData[i].WorkOrderDetails[j].Id,
            //DefectId: ResponseData[i].WorkOrderDetails[j].DefectId,
            lblDefectName: ResponseData[i].WorkOrderDetails[j].DefectName,
            lblMaterialType: ResponseData[i].WorkOrderDetails[j].MaterialType === 1 ? 'Labour' :
              ResponseData[i].WorkOrderDetails[j].MaterialType === 2 ? 'Material' :
                ResponseData[i].WorkOrderDetails[j].MaterialType === 3 ? 'Transport' :
                  ResponseData[i].WorkOrderDetails[j].MaterialType === 4 ? 'Extra' : '',
            lblMaterialName: ResponseData[i].WorkOrderDetails[j].MaterialName,
            lblMaterialCode: ResponseData[i].WorkOrderDetails[j].MaterialCode,
            lblVatRate: ResponseData[i].WorkOrderDetails[j].VatRate,
            lblPrice: ResponseData[i].WorkOrderDetails[j].Price != undefined || ResponseData[i].WorkOrderDetails[j].Price != null ? moneyFormat(ResponseData[i].WorkOrderDetails[j].Price, SessionUser.TenantCode, SessionUser.CurrencyUnit) : 0,
            lblPriceWithVat: ResponseData[i].WorkOrderDetails[j].Price != undefined || ResponseData[i].WorkOrderDetails[j].Price != null ? moneyFormat(ResponseData[i].WorkOrderDetails[j].Price + (ResponseData[i].WorkOrderDetails[j].Price * ResponseData[i].WorkOrderDetails[j].VatRate), SessionUser.TenantCode, SessionUser.CurrencyUnit) : 0,
            lblDiscountPrice: ResponseData[i].WorkOrderDetails[j].DiscountPrice,
            lblCurrencyId: ResponseData[i].WorkOrderDetails[j].CurrencyId,
            lblQuantity: ResponseData[i].WorkOrderDetails[j].Quantity,
            lblProjectCode: ResponseData[i].ProjectCode,
            lblAppointmentDate: ResponseData[i].AppointmentDate,
            lblPostalCode: ResponseData[i]["Consumer"][0]["Addresses"][0].PostCode,
            lblPlaceOfOperation: ResponseData[i].PlaceOfOperation
          }
          result.push(tmp)
        }
      }
    }



    var resultModel = {
      excelDetailedDatas: result,
      tasksScreenResult: taskScreenResult
    };

    yield put(actions.setFilteredTasks(resultModel));

    yield put(actions.setRequestStatus(false));


    return apiResult;
  } catch (error) {
    yield put(actions.setFilteredTasksError(true));
    yield put(actions.setRequestStatus(false));
    console.log(error);
  }
}


function* watchGetFilteredTasksRequest() {
  yield takeEvery(actions.Types.GET_FILTERED_TASKS_REQUEST, getFilteredTasks);
}

const taskSagas = [fork(watchGetTaskRequest), fork(watchGetFilteredTasksRequest)];

export default taskSagas;
